export class ToggleSection {

	constructor(selector, options = {}) {

		this.parent = typeof selector === 'string'
			? document.querySelector(selector)
			: selector;

		if (!this.parent) return;

		const defaultOptions = {
			triggersClass: '.ToggleSectionTriggers',
			triggerClass: '.ToggleSectionTrigger',
			targetsClass: '.ToggleSectionTargets',
			targetClass: '.ToggleSectionTarget',
			dataAttr: 'data-toggle-section-id',
		};

		this.options = Object.assign({}, defaultOptions, options);

		// 🔥 internal event store
		this._events = {};

		this._onClick = this._onClick.bind(this);

		this._setup();
	}

	/* =========================
	   Event Emitter Methods
	========================= */

	on(eventName, handler) {
		if (!this._events[eventName]) {
			this._events[eventName] = [];
		}
		this._events[eventName].push(handler);
		return this;
	}

	off(eventName, handler) {
		if (!this._events[eventName]) return this;

		this._events[eventName] = this._events[eventName]
			.filter(fn => fn !== handler);

		return this;
	}

	emit(eventName, payload = {}) {
		if (!this._events[eventName]) return this;

		this._events[eventName].forEach(handler => {
			handler({
				...payload,
				instance: this
			});
		});

		return this;
	}

	/* ========================= */

	_setup() {
		const triggers = this.parent.querySelectorAll(this.options.triggerClass);

		triggers.forEach(trigger => {
			trigger.addEventListener("click", this._onClick);
		});
	}

	_onClick(event) {

		const trigger = event.currentTarget;

		if (trigger.classList.contains('active')) return false;

		const triggers = this.parent.querySelectorAll(
			`${this.options.triggersClass} ${this.options.triggerClass}`
		);

		const targets = this.parent.querySelectorAll(
			`${this.options.targetsClass} ${this.options.targetClass}`
		);

		const triggerId = trigger.getAttribute(this.options.dataAttr);

		const triggerMatch = Array.from(triggers)
			.some(item => item.getAttribute(this.options.dataAttr) === triggerId);

		const targetMatch = Array.from(targets)
			.some(item => item.getAttribute(this.options.dataAttr) === triggerId);

		if (triggerMatch && targetMatch) {

			this._updateActiveClass(triggers, this.options.dataAttr, triggerId);
			this._updateActiveClass(targets, this.options.dataAttr, triggerId);

			// 🔥 Emit event instead of callback
			this.emit('change', {
				event,
				trigger,
				triggerId
			});
		}
	}

	_updateActiveClass(items, attrLabel, match) {
		items.forEach(item => {
			if (item.getAttribute(attrLabel) === match) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});
	}
}
